import styled from '@app/styled';
import { color, spacing } from '@app/theme';

export const Divider = styled.hr`
    margin-bottom: ${spacing(2)};
    border-top: 1px solid ${color('custom.border.secondary')};
`;

export const FileInput = styled.input`
    && {
        display: none;
    }
`;

export const FileNameSpan = styled.span`
    color: ${color('custom.content.secondary')};
`;

export const SegmentationOptions = styled.div`
    margin-top: ${spacing(2)};
    margin-left: ${spacing(1)};
`;

export const SegmentationCustomContainer = styled.div`
    margin-left: ${spacing(4)};
`;
